import React, {useContext, useReducer, useEffect} from "react";
import {mapEntries} from "radash";

export const deleteCookie = name => {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}

export const readAndParseItsDangerousCookie = cookieName => {

    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        const match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1].replace(/^"|"$/g, '') : null;
    }

    const urlSafeAtob = s => atob(
        s.replace(/_/g, '+').replace(/-/g, '/')
    )

    const cookieString = getCookie(cookieName)

    if(!cookieString) {
        return null
    }

    const parts = cookieString.split('.');

    if (parts.length !== 3) {
      throw new Error(`Invalid cookie format : '${cookieString}'`);
    }

    const decodedTimestampBytes = urlSafeAtob(parts[1])
    const decodedPayload = urlSafeAtob(parts[0])

    const parsedData = JSON.parse(decodedPayload)

    // Convert base64-decoded bytes to an integer (Unix timestamp)
    let signatureTime = 0;
    for (let i = 0; i < decodedTimestampBytes.length; i++) {
      signatureTime = (signatureTime << 8) | decodedTimestampBytes.charCodeAt(i);
    }

    const d = new Date(signatureTime)
    return {
        ...parsedData,
        toString: () => `Session(sigTime: ${signatureTime}, ${format(d, 'yyyy-M-d H:m:s')})`,
    }
}


export const apiSessionReducer = (state, action) => {
    switch (action.name) {
        case "init": {
            return {
                data: {},
                logout: action.logout
            }
        }
        case "refreshSession": {
            const data = readAndParseItsDangerousCookie('session')

            if(action.logLevel > LOG_LEVELS.SILENT) {
                console.log(`refresh session, will expire in ${data.session_timeout_in_seconds/60} minutes`)
            }

            if (state.interval) {
                clearInterval(state.interval)
            }

            if(!data) {
                return state
            }

            return {
                ...state,
                data,
                isLoggedIn: true,
                interval: setInterval(() => {
                    action.triggerSessionExpiry()
                }, data.session_timeout_in_seconds * 1000)
            }
        }
        case "expireSession": {

            return {
                ...state,
                loggedIn: false,
                sessionHasExpired: true
            }
        }
    }
}

export const ApiContext = React.createContext()

const ApiSessionContext = React.createContext()

export function useApi() {
  return useContext(ApiContext)
}

export function useApiSession() {
  return useContext(ApiSessionContext)
}

export const LOG_LEVELS = {
    DEBUG: 2,
    VERBOSE: 1,
    SILENT: 0
}


export const ApiProvider = ({apiDict, children, afterLogoutFunc, onSessionExpired, PipelineInstanceSettingsComponent, logLevel= LOG_LEVELS.SILENT}) => {

    const logout = () => {
        deleteCookie('session')
        if(afterLogoutFunc) {
            afterLogoutFunc()
        }
    }


    const [session, sessionDispatch] = useReducer(
        apiSessionReducer,
        null,
        () => apiSessionReducer(null, {name: 'init', apiDict, logout})
    )

    useEffect(() => {
        sessionDispatch({name: "refreshSession"})
    }, []);

    const triggerSessionExpiry = () => {
        sessionDispatch({name: "expireSession"})
        if(onSessionExpired) {
            onSessionExpired(session)
        }
    }

    const api = mapEntries(apiDict, (funcName, apiFunc) => {
        return [funcName, function() {
            return apiFunc(...arguments).then(res => {
                return new Promise((resolve, reject) => {
                    if(res.status === 200) {
                        sessionDispatch({name: 'refreshSession', triggerSessionExpiry, logLevel})
                        return resolve(res.json())
                    }
                    else {
                        reject(res)
                    }
                })
            })
        }]
    })

    return <ApiSessionContext.Provider value={{...session, PipelineInstanceSettingsComponent}}>
        <ApiContext.Provider
            value={api}
        >
            {children}
        </ApiContext.Provider>
    </ApiSessionContext.Provider>
}
